// extracted by mini-css-extract-plugin
export default {"paper_dialog":"reservedOrdersPopup_paper_dialog__HbnFT","decktop":"reservedOrdersPopup_decktop__e9u5P"};